import React, { useMemo } from 'react';
import CrudManager from '../../common/CrudManager';
import { MessageSquare, Edit2, Trash2 } from 'lucide-react';

const formatTestimonialData = (data) => ({
  nameEn: data.nameEn?.trim() || '',
  role: data.role?.trim() || '',
  quoteEn: data.quoteEn?.trim() || '',
  quoteJa: data.quoteJa?.trim() || undefined,
  order: Number(data.order) || 0,
  isPublished: data.isPublished !== 'false' && data.isPublished !== false,
});

const TestimonialManager = ({ onClose }) => {
  const fields = useMemo(
    () => [
      { name: 'nameEn', label: 'Name', type: 'text', required: true },
      { name: 'role', label: 'Role / Company', type: 'text', required: true },
      {
        name: 'quoteEn',
        label: 'Quote (English)',
        type: 'textarea',
        required: true,
        fullWidth: true,
      },
      {
        name: 'quoteJa',
        label: 'Quote (Japanese)',
        type: 'textarea',
        fullWidth: true,
      },
      { name: 'order', label: 'Display Order', type: 'text', placeholder: '0' },
      {
        name: 'isPublished',
        label: 'Published',
        type: 'select',
        options: [
          { value: 'true', label: 'Published' },
          { value: 'false', label: 'Draft' },
        ],
      },
    ],
    [],
  );

  const renderItem = (item, onEdit, onDelete) => {
    const initials =
      item.nameEn
        ?.split(' ')
        .filter(Boolean)
        .map((p) => p[0])
        .slice(0, 2)
        .join('') || '?';

    return (
      <div className="flex items-start justify-between gap-4 w-full">
        <div className="flex items-start gap-4 flex-1 min-w-0">
          {/* Text-based initial placeholder */}
          <div className="w-12 h-12 rounded-full bg-subidha-blue flex items-center justify-center shrink-0">
            <span className="text-white text-sm font-black uppercase">
              {initials}
            </span>
          </div>

          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-black text-slate-900">{item.nameEn}</h3>
            <p className="text-[11px] text-subidha-blue font-bold">
              {item.role}
            </p>
            <p className="text-xs text-slate-500 truncate">"{item.quoteEn}"</p>
          </div>
        </div>

        <div className="flex items-center gap-1 shrink-0">
          {onEdit && (
            <button
              onClick={() => onEdit(item)}
              className="p-2.5 rounded-xl text-slate-400 hover:text-subidha-blue"
            >
              <Edit2 className="w-4 h-4" />
            </button>
          )}
          {onDelete && (
            <button
              onClick={() => onDelete(item)}
              className="p-2.5 rounded-xl text-slate-400 hover:text-red-500"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <CrudManager
      title="Manage Testimonials"
      apiEndpoint="/testimonials"
      icon={MessageSquare}
      fields={fields}
      renderItem={renderItem}
      onClose={onClose}
      emptyMessage="No testimonials yet."
      formatCreateData={formatTestimonialData}
      formatUpdateData={formatTestimonialData}
    />
  );
};

export default TestimonialManager;
